export default function IndividualLimitGuidance({ isCustom, id, className = '' }) {
    return (
        <p id={id} className={`text-sm text-gray-600 mb-0 ${className}`}>
            {isCustom ? (
                <>
                    <span className="font-medium">Not enforced for custom workflow payments.</span>{' '}
                    Saved individual limits still apply to payments using standard approval, including existing
                    standard payments. Editing a limit does not change custom workflow permissions.
                </>
            ) : 'Individual user authorisation limits apply to payments using standard approval.'}
        </p>
    );
}
